import { FieldHelperProps, FieldInputProps, FieldMetaProps, useField } from 'formik';
import { FormattedMessage } from 'react-intl';
import { ReactElement } from 'react';

import { PoolAutocomplete, PoolAutocompleteProps } from './pool-autocomplete';

export interface PoolFormikAutocompleteProps<T = number> extends Omit<PoolAutocompleteProps<T>, 'onChange'> {
    name: string;
    onChange?: (
        value: T | null,
        helper: FieldHelperProps<T | null>,
        field: FieldInputProps<T | null>,
        meta: FieldMetaProps<T | null>
    ) => void;
    getValue?: (value: T | null) => T | null;
    getDisplayValue?: (value: T | null) => string;
}

export const PoolFormikAutocomplete = <T,>(props: PoolFormikAutocompleteProps<T>): ReactElement => {
    const { onChange, name, getValue, getDisplayValue, ...rest } = props;
    const [field, meta, helper] = useField<T | null>({ name });

    const handleChange = (option: T | null): void => {
        helper.setValue(option);
        onChange?.(option, helper, field, meta);
    };

    const value = rest.value ?? getValue?.(field.value) ?? field.value;

    return (
        <PoolAutocomplete
            error={meta.touched && !!meta.error}
            helperText={meta.touched && meta.error ? <FormattedMessage id={meta.error} /> : ' '}
            name={field.name}
            onChange={handleChange}
            {...rest}
            value={value}
            displayValue={getDisplayValue && getDisplayValue(value)}
        />
    );
};
